import AddTemplate from "./add-template/add-template";
import Templates from "./templates";
import { TEMPLATE_EDITOR_PATHS } from "./utils/constant";
import { ProtectedRoute } from "@/components";

export const templateEditorRoutes = (modulePath: string, module: string)  => [
	{
		path: `${TEMPLATE_EDITOR_PATHS.TEMPLATES_LIST('email')}`,
		element: <ProtectedRoute module="Templates" action="canView"><Templates type="email" module={module} modulePath={modulePath}/></ProtectedRoute>
	},
	{
		path: `${TEMPLATE_EDITOR_PATHS.TEMPLATES_ADD('email')}`,
		element: <ProtectedRoute module="Templates" action="canView"><AddTemplate modulePath={modulePath} type="email" module={module}/></ProtectedRoute>
	},
	{
		path: `${TEMPLATE_EDITOR_PATHS.TEMPLATES_EDIT('email')}`,
		element: <ProtectedRoute module="Templates" action="canView"><AddTemplate modulePath={modulePath} type="email" module={module}/></ProtectedRoute>
	},
	{
		path: `${TEMPLATE_EDITOR_PATHS.TEMPLATES_LIST('pdf')}`,
		element:
		//  <ProtectedRoute module="Templates" action="canView">
			<Templates module={module} type="pdf" modulePath={modulePath}/>
			// </ProtectedRoute>	
	},
	{
		path: `${TEMPLATE_EDITOR_PATHS.TEMPLATES_ADD('pdf')}`,
		element:
		//  <ProtectedRoute module="Templates" action="canView">
			<AddTemplate modulePath={modulePath} type="pdf" module={module}/>
			// </ProtectedRoute>
	},
	{
		path: `${TEMPLATE_EDITOR_PATHS.TEMPLATES_EDIT('pdf')}`,
		element: 
		//  <ProtectedRoute module="Templates" action="canView">
			<AddTemplate modulePath={modulePath} type="pdf" module={module}/>
			// </ProtectedRoute>
	}
]